// React Thirty Party Library
import { Tag, Badge } from "antd";

// Service Library
import { TIME } from "../../../services/util";

const { parseMonth } = TIME;

export const getColumnsFilterStatus = (options) => {
  return Object.values(options).map((o) => ({
    text: (
      <div
        style={{
          backgroundColor: o.bgColor,
          display: "inline-block",
          padding: "3px 13px",
          borderRadius: "30px",
        }}
      >
        <Badge
          color={o.colorTag}
          text={
            <span style={{ color: o.colorTag }}>{o.display || o.name}</span>
          }
        />
      </div>
    ),
    value: o.status,
  }));
};

export const getColumnsFilterGroup = (options) => {
  return Object.values(options).map((o) => ({
    text: (
      <Tag color={o.color} style={{ color: "black" }}>
        {o.name}
      </Tag>
    ),
    value: o.name,
  }));
};

export const getColumnsFilterType = (options) => {
  return Object.values(options)
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((o) => ({
        text: `${o.name} /${o.coid}`,
        value: o.coid,
      }));
};

export const getBillingMonthFilters = (billingData) => {

  const uniqueBillingMonths = [
    ...new Set(
      Object.values(billingData).map((record) => parseMonth(record.billedAt))
    ),
  ];

  return uniqueBillingMonths.sort().map((month) => ({
    text: month,  
    value: month, 
  }));
};

export const getColumnsCompanyName = (options) => {
  const uniqueNames = {};
  const result = [];

  Object.values(options).forEach((o) => {
    if (!uniqueNames[o.name]) {
      uniqueNames[o.name] = true;
      result.push({ text: `${o.name}`, value: o.name });
    }
  });

  return result;
};


// export const getColumnsFilterType = (options) => {
//   return Object.values(options).map((o) => ({
//     text: `${o.name} /${o.coid}`,
//     value: o.coid,
//   }));
// };

export const tableData = (
  data,
  filteredInfo,
  sortedInfo,
) => {
  let filtered = [...data]; // Use originalData for filtering and sorting


  // Apply sorting
  const { columnKey, order } = sortedInfo;
  if (columnKey) {
    filtered = filtered.sort((a, b) => {
      const aValue = a[columnKey];
      const bValue = b[columnKey];

      if (
        aValue === "-" ||
        aValue === undefined ||
        aValue === null ||
        aValue === 0
      ) {
        return 1;
      }

      if (
        bValue === "-" ||
        bValue === undefined ||
        bValue === null ||
        bValue === 0
      ) {
        return -1;
      }
      if (order === "descend") {
        if (columnKey === "name" || columnKey === "employee_name") {
          return aValue.localeCompare(bValue);
        }
        return aValue - bValue;
      } else {
        if (columnKey === "name" || columnKey === "employee_name") {
          return bValue.localeCompare(aValue);
        }
        return bValue - aValue;
      }
    });
  }

  // Apply filtering
  Object.entries(filteredInfo).forEach(([key, value]) => {
    if (Array.isArray(value) && value.length > 0) {
      const valuesLower = value.map((v) => v.toString().toLowerCase());
      filtered = filtered.filter((item) => {
        if (key === "employee_name") {
          return valuesLower.some(
            (valueLower) =>
              item.employee_name?.toLowerCase().includes(valueLower) ||
              item.employee_contact?.toLowerCase().includes(valueLower)
          );
        } else {
          return valuesLower.some((val) =>
            item[key]?.toString().toLowerCase().includes(val)
          );
        }
      });
    }
  });

  return filtered;
}

// export const tableData2 = (
//   data,
//   tabKey,
//   filteredInfo,
//   sortedInfo,
//   originalData
// ) => {
//   let filtered = [...data[tabKey]];

//   const { columnKey, order } = sortedInfo;
//   if (columnKey) {
//     let k = columnKey;
//     filtered = data[tabKey].sort((a, b) => {
//       const aValue = a[k];
//       const bValue = b[k];

//       if (
//         aValue === "-" ||
//         aValue === undefined ||
//         aValue === null ||
//         aValue === 0
//       ) {
//         return 1;
//       }

//       if (
//         bValue === "-" ||
//         bValue === undefined ||
//         bValue === null ||
//         bValue === 0
//       ) {
//         return -1;
//       }
//       if (order === "descend") {
//         if (k === "name") {
//           return aValue.localeCompare(bValue);
//         }
//         return aValue - bValue;
//       } else {
//         if (k === "name") {
//           return bValue.localeCompare(aValue);
//         }
//         return bValue - aValue;
//       }
//     });
//   }

//   Object.entries(filteredInfo).forEach(([key, value]) => {
//     if (Array.isArray(value) && value.length > 0) {
//       const valuesLower = value.map((v) => v.toString().toLowerCase());
//       filtered = data[tabKey].filter((item) => {
//         if (key === "employee_name") {
//           return valuesLower.some(
//             (valueLower) =>
//               item.employee_name?.toLowerCase().includes(valueLower) ||
//               item.employee_contact?.toLowerCase().includes(valueLower)
//           );
//         } else {
//           return valuesLower.some((val) =>
//             item[key]?.toString().toLowerCase().includes(val)
//           );
//         }
//       });
//     }
//   });

//   if (Object.values(filteredInfo).every((d) => !d || d.length === 0)) {
//     filtered = originalData;
//   }
//   return filtered;
// };

// export const sortingDataTable = (data, tabKey, sortedInfo) => {
//   if (!Array.isArray(data[tabKey])) {
//     data[tabKey] = [data[tabKey]];
//   }
//   let filtered = [...data[tabKey]];

//   function addNegative(number) {
//     let str = number.toString();
//     if (!str.startsWith("-")) {
//       str = "-" + str;
//     }
//     return parseInt(str, 10);
//   }
//   const { columnKey, order } = sortedInfo;

//   filtered.sort((a, b) => {
//     const asc =
//       columnKey === "name"
//         ? a[columnKey].localeCompare(b[columnKey])
//         : a[columnKey] - b[columnKey];
//     const desc =
//       columnKey === "name"
//         ? b[columnKey].localeCompare(a[columnKey])
//         : b[columnKey] - a[columnKey];

//     const ascMin = addNegative(asc);
//     const dscMin = addNegative(desc);

//     const res = order === "descend" ? dscMin : ascMin;
//     return res;
//   });

//   // if (sortedInfo && sortedInfo.columnKey) {
//   //   let sortFiltered;
//   //   const { columnKey, order } = sortedInfo;
//   //   const sortFunction = sortFunctions[columnKey];
//   //   if (sortFunction) {
//   //     sortFiltered = filtered.sort((a, b) => {
//   //       const result = sortFunction(a, b);
//   //       // return order === 'descend' ? -result : result;
//   //     });
//   //     filtered = sortFiltered
//   //   }
//   // }

//   // const { columnKey, order, column } = sortedInfo;
//   // if (sortedInfo && sortedInfo.columnKey) {
//   //   let sortFiltered;
//   //   sortFiltered = filtered.sort((a, b) => {
//   //     const asc =
//   //       columnKey === "name"
//   //         ? a[columnKey].localeCompare(b[columnKey])
//   //         : a[columnKey] - b[columnKey];
//   //     const desc =
//   //       columnKey === "name"
//   //         ? b[columnKey].localeCompare(a[columnKey])
//   //         : b[columnKey] - a[columnKey];

//   //     const res = order === "descend" ? desc: asc;
//   //     return res;
//   //   });
//   // }
//   // filtered = column?.sorter;

//   return filtered;
// };
